import { render } from "./BaseMobileOptionFooter.vue?vue&type=template&id=37a7037c&scoped=true"
import script from "./BaseMobileOptionFooter.vue?vue&type=script&lang=js"
export * from "./BaseMobileOptionFooter.vue?vue&type=script&lang=js"

import "./BaseMobileOptionFooter.vue?vue&type=style&index=0&id=37a7037c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a7037c"]])

export default __exports__